import { apiRequest } from "../auth/api-request";
import { ApiResponse } from "../dtos/api-respone.model";
import { User, UserEmail } from "../dtos/user.model";
import { EntityService, IGetAllParams } from "./entity-service";

export class CompanyUserService extends EntityService<User> {
  baseUrl: string;
  constructor(id: number) {
    super();
    this.baseUrl = `companies/${id}/users`;
  }

  getAll(queries: IGetAllParams) {
    return apiRequest
      .get<ApiResponse<User[]>>(`${this.baseUrl}`, { params: { ...queries } })
      .then((o) => {
        return {
          ...o.data,
          data: o.data.data.map((user) => new User(user)),
        };
      });
  }

  getOne(userId: number, queries?: IGetAllParams) {
    return apiRequest
      .get<ApiResponse<User>>(`${this.baseUrl}/${userId}`, {
        params: { ...queries },
      })
      .then((o) => new User(o.data.data));
  }

  update(userId: number, dto: Omit<User, "fullName">) {
    return apiRequest
      .put<ApiResponse<User>>(`${this.baseUrl}/${userId}`, { ...new User(dto) })
      .then((o) => new User(o.data.data));
  }

  delete(userId: number) {
    return apiRequest.delete(`${this.baseUrl}/${userId}`);
  }

  getExistingEmails(emails: string[]): Promise<UserEmail[]> {
    return apiRequest
      .get<ApiResponse<UserEmail[]>>(`${this.baseUrl}/by-email`, {
        params: {
          emails,
        },
      })
      .then((response) => response.data.data.map((u) => new UserEmail(u)));
  }
}
